// extracted by mini-css-extract-plugin
export default {"carImageTitle":"CarImageTitle-module__carImageTitle--n0EUO","carImageSubtitle":"CarImageTitle-module__carImageSubtitle--uoVxC"};